import { LandingLocaleSwitcher } from '@/components/landing/LandingLocaleSwitcher'
import { GuestPageBackground } from '@/components/layout/GuestPageBackground'
import { useMinCopy } from '@/i18n/useUiLocale'
import type { ReactNode } from 'react'

/** Auth pages shell: background + locale switcher (guest locale continuity). */
export function GuestAuthShell({ children }: { children: ReactNode }) {
  const copy = useMinCopy({ preferGuest: true })

  return (
    <div className="relative flex min-h-screen items-center justify-center px-4 py-10">
      <GuestPageBackground />
      <div className="absolute right-4 top-4 z-20 sm:right-6 sm:top-6">
        <LandingLocaleSwitcher ariaLabel={copy.auth.localeSwitcherLabel} />
      </div>
      {children}
    </div>
  )
}
